var map = {
	"./municipiosPara": [
		"UW76",
		1
	],
	"./municipiosPara.json": [
		"UW76",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "y0SO";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/libs/static/municipio/seeds lazy ^\.\/.*$
// module id = y0SO
// module chunks = 5